import { Api } from "@mcleod/core";
import { AutogenLayoutTotalFuelReport } from "./autogen/AutogenLayoutTotalFuelReport";
import { LayoutProvidedReportDecoratorProps } from "@mcleod/components";

export class FuelTotalsReport extends AutogenLayoutTotalFuelReport {
  
    override async onLoad(): Promise<void> {
        this.textboxFuelInterfaceId.visible = false;
        this.textboxFuelInterfaceId.required = false;
        Api.search("lme/dispatch/asset/fuel-interface-configured", {}).then(async (response) => {
            this.textboxFuelInterfaceId.visible = response.data.length >= 2;
            this.textboxFuelInterfaceId.required = response.data.length >= 2;
        });
    }

         get reportDecoratorProps(): Partial<LayoutProvidedReportDecoratorProps> {
        return {
            doOnResetForm: () => Api.search("lme/dispatch/asset/fuel-interface-configured", {}).then(async (response) => {
                this.textboxFuelInterfaceId.visible = response.data.length >= 2;
                this.textboxFuelInterfaceId.required = response.data.length >= 2;

            })
        };
    }
    
}